import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {Avatar, styles, Typography} from '../../index';

import CircularProgress from '../CircularProgress.jsx';
import LinearProgress from '../LinearProgress.jsx';
const {makeStyles} = styles;

const ProviderHeader = (props) => {
  const classes = useStyles(props);
  const {
    avatarUrl,
    name,
    // specialty,
    loading = false,
    nameTestId,
    specialtyTestId,
    visitType,
    scheduledType,
    titleTestId,
  } = props;


  const initials = React.useMemo(() => {
    if (!props.name) return '';
    const parts = props.name.split(' ');
    if (parts.length === 0) return '';
    const firstName = parts[0];
    if (parts.length > 1) {
      return `${firstName.charAt(0)}${_.last(parts).charAt(0)}`;
    } else {
      return firstName.charAt(0);
    }
  }, [props.name]);

  if (scheduledType === 'now' && !name) {
    return (
      <div className={classes.root}>
        <div className={classes.nowIcon}>
          { avatarUrl }
        </div>
        {
          loading && (
            <LinearProgress variant={'indeterminate'} color={'primary'} />
          )
        }
        {
          !loading && (
            <div className={ classes.text }>
              <Typography
                variant={ 'body1' }
                className={ classes.title }>
                ON DEMAND VISIT
              </Typography>
              <Typography
                variant={ 'caption' }
                className={ classes.name }>
                {visitType === 'medical' ? 'MedicalNow' : 'TalkNow'}
              </Typography>
            </div>
          )
        }
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <Avatar src={avatarUrl} className={classes.avatar}>
        {
          !avatarUrl
            ? initials
            : loading
              ? <CircularProgress variant={'indeterminate'} size={'small'} />
              : undefined
        }
      </Avatar>
      {
        loading && (
          <LinearProgress variant={'indeterminate'} color={'primary'} />
        )
      }
      {
        !loading && (
          <div className={ classes.text }>
            <Typography
              variant={ 'h2' }
              className={ classes.title }
              data-testid={titleTestId}>
              { scheduledType === 'now'
                ? 'ON DEMAND VISIT'
                : 'SCHEDULED VISIT'
              }
            </Typography>
            <Typography
              variant={ 'caption' }
              className={ classes.name }
              data-testid={nameTestId}>
              { name }
            </Typography>
            <Typography
              variant={ 'caption' }
              className={ classes.visitType }
              data-testid={specialtyTestId}>
              { visitType === 'hc'
                ? 'Health Coaching'
                : _.capitalize(visitType)
              }
            </Typography>
          </div>
        )
      }
    </div>
  );
};

ProviderHeader.propTypes = {
  avatarUrl: PropTypes.string,
  name: PropTypes.string.isRequired,
  // specialty: PropTypes.string,
  loading: PropTypes.bool,
  nameTestId: PropTypes.string,
  specialtyTestId: PropTypes.string,
  titleTestId: PropTypes.string,
  visitType: PropTypes.string.isRequired,
  scheduledType: PropTypes.string.isRequired,
};

const useStyles = makeStyles(
    (theme) => ({
      root: {
        display: 'flex',
        minHeight: 76,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: `${theme.spacing(2)}px, 0`,
      },
      avatar: {
        height: 72,
        width: 72,
        marginRight: theme.spacing(2),
      },
      text: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
      },
      title: {
        color: '#FFFFFF',
        fontSize: 18,
        fontWeight: 700,
        lineHeight: 1.5,
        letterSpacing: '0.00938em',
      },
      name: {
        color: '#FFFFFF',
        fontSize: 16,
        fontWeight: 500,
      },
      visitType: {
        color: '#FFFFFF',
        fontSize: 16,
        fontWeight: 400,
      },
      nowIcon: {
        marginRight: 14,
      },
    }),
);

export default ProviderHeader;
